/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-misused-promises */

import http from 'hub-http/clients/apiClient';
import noAuthHttp from 'hub-http/clients/noAuthApiClient';
import { getFullUrl } from 'hubspot-url-utils';
import getEarlyRequesterResult from 'pricing-pages-lib/api/getEarlyRequesterResult';
import { PURCHASE_MOTIONS } from '../constants/EarlyRequesterNames';
import { getIsQAProxy } from '../utils/proxyUtils';
import { getSeatsCountryCode } from '../utils/seatsUtils';
const ENDPOINT = 'monetization/v3/purchase-motions';
const PUBLIC_ENDPOINT = 'monetization/v3/purchase-motions/public-pricing';
export const getPurchaseMotionsByLocation = locations => {
  const earlyRequest = getEarlyRequesterResult('purchase-motions');
  const standardGet = () => http.get(ENDPOINT, {
    query: {
      location: locations
    }
  });
  const earlyRequestWithRetry = earlyRequest ? earlyRequest.catch(() => standardGet()) : null;
  return earlyRequestWithRetry || standardGet();
};
export const getPublicPurchaseMotionsByLocation = (locations, browserLocale = 'en-us') => {
  const earlyRequest = getEarlyRequesterResult(PURCHASE_MOTIONS);
  const countryCode = getSeatsCountryCode() || window.COUNTRY_CODE_FROM_LOCALE && window.COUNTRY_CODE_FROM_LOCALE.toUpperCase();
  const url = `${getFullUrl('app-api', getIsQAProxy() ? {
    envOverride: 'qa'
  } : {})}/${PUBLIC_ENDPOINT}/${browserLocale}${countryCode ? `?countryCode=${countryCode}` : ''}`;
  const standardGet = () => noAuthHttp.get(url, {
    query: {
      location: locations
    }
  });
  const earlyRequestWithRetry = earlyRequest ? earlyRequest.catch(() => standardGet()) : null;
  return earlyRequestWithRetry || standardGet();
};